import {kFlashImages} from "../../../constants/images";
import {kFlashTexts, kSystemTexts} from "../../../constants/texts";

export default function CoursesNoGradeSelected() {
    // Used in ParameterSubthemesContent to display
    // message when no Grade has been selected

    // BUILD
    return (
        <div className={"animate-appear w-full h-full flex flex-col justify-start items-center shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] rounded-[16px] mt-[24px]"}>
            <div className={"bg-backgroundLight5 w-full flex items-center shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] rounded-t-[16px]"}>
                <div className={"flex justify-start items-center space-x-[4px] w-[266px] min-w-[266px] lg:w-[320px] lg:min-w-[320px] px-[16px] py-[12px]"}>
                    <span className={"text-[16px] font-medium text-greyLight11"}>
                        {kSystemTexts.themes}
                    </span>
                </div>
                <div className={"h-full w-[1px] min-w-[1px] bg-greyLight3"}>
                </div>
                <div className={"w-full px-[16px] flex justify-start items-center py-[12px]"}>
                    <div className={"flex justify-start items-center space-x-[4px]"}>
                        <span className={"text-[16px] font-medium text-greyLight11"}>
                            {kSystemTexts.skills}
                        </span>
                    </div>
                </div>
            </div>
            <div className={"grow flex flex-col justify-center items-center space-y-[12px]"}>
                <div className={`h-[136px] min-h-[136px]`}>
                    <img className={"object-contain h-full"}
                         src={kFlashImages.noGradeSelected}
                         alt="Ours avec stylo et cahier" />
                </div>
                <span className={"w-[400px] font-medium text-center text-[16px] text-greyLight7 whitespace-pre-line"}>
                    {kFlashTexts.noGradeSelected}
                </span>
            </div>
        </div>
    );
}